import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ConnectedPosition } from '@angular/cdk/overlay';

export interface TaxLine {
  description?: string;
  amount?: number;
  included?: boolean;
  // Moneda propia de esta línea. Cuando no viene, se usa el @Input() currency
  // general del tooltip (caso de una sola moneda para todas las líneas).
  currency?: string;
}

export interface NetTotalInfo {
  amountConverted: number;
  agencyCurrency: string;
  amountOriginal: number;
  originalCurrency: string;
}

export interface DailyPriceLine {
  date: string;
  price: number;
  currency: string;
}

/**
 * Tooltip de discriminación de impuestos (incluidos / a pagar en destino), con el mismo formato
 * visual que usb-tooltip-convert-amount (mismo trigger, mismo overlay CDK, misma tabla) para que
 * ambos tooltips se vean consistentes donde se usen juntos. netTotal/dailyPrices son opcionales:
 * sin ellos el tooltip queda igual que en el modal de hotel; con ellos (ver item-status) también
 * muestra la tarifa neta y el valor por noche.
 */
@Component({
  selector: 'usb-tooltip-taxes-breakdown',
  templateUrl: './tooltip-taxes-breakdown.component.html',
  styleUrls: ['./tooltip-taxes-breakdown.component.scss']
})
export class TooltipTaxesBreakdownComponent implements OnChanges {
  @Input() taxes: TaxLine[] = [];
  @Input() currency?: string;
  @Input() clientsSettingAppBooking: any;
  @Input() netTotal?: NetTotalInfo;
  @Input() dailyPrices?: DailyPriceLine[];

  public taxesIncluded: TaxLine[] = [];
  public taxesExcluded: TaxLine[] = [];
  public isTooltipOpen = false;

  public overlayPositions: ConnectedPosition[] = [
    { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top', offsetY: 8 },
    { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom', offsetY: -8 },
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 8 },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: -8 }
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.taxes) {
      const list = this.taxes || [];
      this.taxesIncluded = list.filter(tax => tax.included);
      this.taxesExcluded = list.filter(tax => !tax.included);
    }
  }

  getDayName(dateStr: string): string {
    const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const date = new Date(dateStr + 'T00:00:00');
    return days[date.getDay()];
  }

}
